import {logEventToDB} from '../helper'

const carnotEventStore = {
  actions: {
    async logEvent (context, payload) {
      await logEventToDB({
        facility_name: context.rootState.pointsListStore.pointsList.facility_name,
        type:payload.type,
        data:payload.data,
        source:process.env.VUE_APP_MOBILE_MODE ? "carnotMobile" : "carnotDashboard"
      })

    }
  },
}


export default carnotEventStore
